import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpServiceBase } from '../classes/HttpServiceBase';

/**
 * Admin file-access categories CRUD (backend rest/fyes/admin/categories).
 * The interceptor prepends environment.serverUrl.
 */
@Injectable({ providedIn: 'root' })
export class AdminCategoriesService extends HttpServiceBase {
    protected override baseUrl = '/admin/categories';

    constructor(private http: HttpClient) {
        super();
        this.assign(this);
    }

    public list(): Observable<any> {
        return this._http.get(this.baseUrl)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    public create(categoryName: string): Observable<any> {
        return this._http.post(this.baseUrl, { categoryName })
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    public update(id: string, categoryName: string): Observable<any> {
        return this._http.put(`${this.baseUrl}/${id}`, { categoryName })
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    public delete(id: string): Observable<any> {
        return this._http.delete(`${this.baseUrl}/${id}`)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }
}
